import React, { useState, useEffect } from 'react';
import { useSidebar } from '../../SidebarContext';
import { useSearch } from '../../SearchContext';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Loader from '../Loader';
import CatlogModal from './CatlogModal';
import { decryptToken } from '../utils/getToken';
import { useLocation } from 'react-router-dom';

const Catlog = () => {

    const { globalSearch } = useSearch();
    const [brands, setBrands] = useState([]);
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [load, setLoad] = useState(false);
    const [data, setData] = useState({
        id: "",
        name: "",
        brand_id: "",
        image_url: "",
        position: "",
        status: "",
        customer_no: "",
        customer_email: "",
        description: "",
    })
    const [edit, setEdit] = useState(false);
    const urlmain = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""

    const itemsPerPage = 10;
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("openBrand") === "true") {
            const newUrl = `${window.location.pathname}`;
            window.history.replaceState({}, "", newUrl);
            setIsModalOpen(true)
        }
    }, [location]);

    // Dummy Data
    // const dummyBrands = [
    //     { id: 1, icon: "https://via.placeholder.com/50", brand: "Greenply", position: 1, status: "Active" },
    //     { id: 2, icon: "https://via.placeholder.com/50", brand: "Bajaj", position: 2, status: "Inactive" },
    //     { id: 3, icon: "https://via.placeholder.com/50", brand: "Havells", position: 3, status: "Active" },
    //     { id: 4, icon: "https://via.placeholder.com/50", brand: "Century Ply", position: 4, status: "Inactive" },
    //     { id: 5, icon: "https://via.placeholder.com/50", brand: "Jaquar", position: 5, status: "Active" },
    //     { id: 6, icon: "https://via.placeholder.com/50", brand: "Crompton", position: 6, status: "Active" },
    //     { id: 7, icon: "https://via.placeholder.com/50", brand: "Godrej Hardware", position: 7, status: "Inactive" },
    //     { id: 8, icon: "https://via.placeholder.com/50", brand: "Anchor by Panasonic", position: 8, status: "Active" },
    // ];

    const fetchBrand = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${urlmain}/catlog`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            setBrands(res);
            setLoad(false);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        // setLoad(true);
        // setTimeout(() => {
        //     setBrands(dummyBrands);
        //     setLoad(false);
        // }, 500);
        fetchBrand();
    }, []);

    useEffect(() => {
        const filtered = brands.filter((brand) =>
            Object.values(brand).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredBrands(filtered);
        setCurrentPage(1);
    }, [globalSearch, brands]);

    // Pagination
    const totalPages = Math.ceil(filteredBrands.length / itemsPerPage);
    const currentData = filteredBrands.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Brand Status
    const toggleStatus = async (id) => {

        try {
            const res = await fetch(`${urlmain}/catlog/status/${id}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || "Failed to update status");
            }

            // Update local state with new status
            setBrands((prev) =>
                prev.map((b) =>
                    b.id === id
                        ? { ...b, status: b.status === "Active" ? "Inactive" : "Active" }
                        : b
                )
            );

            // Show message from backend
            toast.success(data.message);

        } catch (error) {
            console.error("Error updating status:", error);
            toast.error(error.message || "Failed to update status");
        }
    };


    // Delete Brand
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "This brand will be removed!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
        });

        if (result.isConfirmed) {
            try {
                const res = await fetch(`${urlmain}/catlog/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                });

                if (!res.ok) throw new Error("Failed to delete brand");

                Swal.fire('Deleted!', 'Brand has been deleted.', 'success');
                setBrands(prev => prev.filter(b => b.id !== id));

            } catch (error) {
                console.error("Delete error:", error);
                Swal.fire('Error!', 'Failed to delete brand.', 'error');
            }
        }
    };
    // Save Brand (Dummy Add/Edit)
    const handleSave = (data) => {
        if (data.id) {
            setBrands(prev => prev.map(b => (b.id === data.id ? data : b)));
            toast.success("Brand updated");
        } else {
            const newBrand = { ...data, id: brands.length + 1 };
            setBrands(prev => [...prev, newBrand]);
            toast.success("Brand added");
        }
    };

    if (load) return <Loader />;

    return (
        <>
            <div className="oms-header">
                <h1 className="dashboard-title">Catlog</h1>
            </div>

            {/* Table View */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th>Icon</th>
                            <th>Brand Name</th>
                            {/* <th>Position</th> */}
                            {/* <th>Status</th> */}
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((brand, index) => (
                                <tr key={index}>
                                    <td>
                                        <img src={brand.image} alt="" className="w-12 h-12 rounded-full" />
                                    </td>
                                    <td>{brand.name}</td>
                                    {/* <td>{brand.position}</td> */}
                                    {/* <td>
                                        <button
                                            className={`status-toggle ${brand.status}`}
                                            onClick={() => toggleStatus(brand.id)}
                                        >
                                            {brand.status === "Active" ? (
                                                <i className="fas fa-toggle-on"></i>
                                            ) : (
                                                <i className="fas fa-toggle-off"></i>
                                            )}
                                        </button>
                                    </td> */}
                                    <td>
                                        <button
                                            className="edit-button"
                                            onClick={() => {
                                                setData({
                                                    id: brand.id,
                                                    name: brand.name,
                                                    category_id: brand.category_id,
                                                    image: brand.image,
                                                    pdf: brand.pdf,
                                                    position: brand.position,
                                                    status: brand.status,
                                                    customer_no: brand.customer_no,
                                                    customer_email: brand.customer_email,
                                                    description: brand.description
                                                })
                                                setEdit(true)
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>
                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(brand.id)}
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                    No Catlog Added.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Responsive Card View */}
            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p style={{ textAlign: "center", margin: "50px" }}>No Catlog Added</p>
                ) : (
                    currentData.map((brand, index) => (
                        <div className="ecom-responsive-card" key={index}>
                            <div className="ecom-responsive-header">
                                <div className="p-toggle">
                                    <p
                                        onClick={() => {
                                            setData({
                                                id: brand.id,
                                                name: brand.name,
                                                category_id: brand.category_id,
                                                image: brand.image,
                                                pdf: brand.pdf,
                                                position: brand.position,
                                                status: brand.status,
                                                customer_no: brand.customer_no,
                                                customer_email: brand.customer_email,
                                                description: brand.description
                                            })
                                            setEdit(true)
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        <Pencil size={20} /> <span>Edit</span>
                                    </p>
                                    {/* <button
                                        className={`status-toggle ${brand.status}`}
                                        onClick={() => toggleStatus(brand.id)}
                                    >
                                        {brand.status === "Active" ? (
                                            <>
                                                <LucideToggleRight /> <span>Active</span>
                                            </>
                                        ) : (
                                            <>
                                                <LucideToggleLeft /> <span>Inactive</span>
                                            </>
                                        )}
                                    </button> */}
                                </div>
                                <p onClick={() => handleDelete(brand.id)}>
                                    <Trash2 size={20} /> <span>Delete</span>
                                </p>
                            </div>

                            <div className="ecom-responsive-body">
                                <div className="ecom-responsive-left">
                                    <div className="ecom-image-heading-left">
                                        <img
                                            src={brand.image}
                                            alt=""
                                            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                                        />
                                        <span>
                                            <h2>{brand.name}</h2>
                                            {/* <p>Position: {brand.position}</p> */}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination">
                    <button
                        onClick={() => paginate(1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronsLeft size={18} />
                    </button>
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-chev-btn"
                    >
                        <ChevronLeft size={18} />
                    </button>
                    <button className="pagination-btn active">{currentPage}</button>
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronRight size={18} />
                    </button>
                    <button
                        onClick={() => paginate(totalPages)}
                        disabled={currentPage === totalPages}
                        className="pagination-chev-btn"
                    >
                        <ChevronsRight size={18} />
                    </button>
                </div>
            )}

            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                <button
                    onClick={() => {
                        setIsModalOpen(true);
                        setData({
                            name: "",
                            brand_id: "",
                            image_url: "",
                            position: "",
                            status: "",
                            customer_no: "",
                            customer_email: "",
                            description: ""
                        })
                    }}
                    className="cssbuttons-io-button">
                    <span>Add Catlog</span>
                </button>
            </div>

            <CatlogModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                selectedCategory={selectedBrand}
                setSelectedCategory={setSelectedBrand}
                onSave={handleSave}
                categories={brands}
                setCategories={setBrands}
                fetchCategories={fetchBrand}
                data={data}
                setData={setData}
                isEdit={edit}
            />
        </>
    );
};

export default Catlog;
